import { useMutation } from '@tanstack/react-query'
import { IRequestData } from '@zet/customer/src/api/functions/customerAdditionStateMachine'
import { isIOS, isWebView } from '@zet/integration-flow/utils'
import { zetApi } from '@zet/network'

const editBasicDetails = async (requestData: IRequestData) => {
  const { data } = await zetApi.post('jfs/editCustomerDetails', requestData, {
    headers: {
      ...zetApi.defaults.headers.common,
      appOs: !isWebView() ? 'web' : isIOS() ? 'ios' : 'android',
    },
  })
  if (data?.data) {
    return data.data
  } else {
    return data?.error
  }
}

const useEditBasicDetails = () => {
  return useMutation(editBasicDetails, {
    mutationKey: ['editBasicDetails'],
  })
}

export { useEditBasicDetails }
